<template>
  <div class="favorite-overview-list">
    <sport v-for="sport in sports" :key="sport.id" :sport="sport" type="live" :group="$store.getters['live/OVERVIEW_GROUP'](sport.id)">
      <league
        :favorite="favoriteLeagues.indexOf(league.id) !== -1"
        class="league"
        v-for="league in sport.leagues"
        :key="league.id"
        :league="league"
        :sport="sport">
        <event
          :favorite="favoriteEvents.indexOf(event.id) !== -1"
          class="event"
          v-for="(event, i) in league.events"
          :key="event.id"
          :event="event"
          :sport="sport"
          :f="i === 0"
          :l="i == league.events.length - 1" />
      </league>
    </sport>
  </div>
</template>

<script>
import Sport from '@/components/sports/matches/Sport'
import League from '@/components/sports/matches/League'
import Event from '@/components/live/overview/Event'
import { mapState } from 'vuex'

export default {
  components: { Sport, League, Event },
  computed: {
    ...mapState({
      sports: state => state.favorites.live.sports,
      favoriteLeagues: state => state.favorites.leagues,
      favoriteEvents: state => state.favorites.events
    })
  },
  watch: {
    '$route' (to, from) {
      this.getOverview()
    },
    '$i18n.locale' (to, from) {
      let view = document.querySelector('#favorite-overview-scrollbar')
      this.$store.dispatch('favorites/GET_OVERVIEW', {
        params: {
          top: view.scrollTop,
          height: view.clientHeight
        },
        type: 'live',
        loader: false
      })
    }
  },
  data () {
    return {
      updateInteval: null
    }
  },
  mounted () {
    this.getOverview()

    const dispatchGetting = () => {
      let view = document.querySelector('#favorite-overview-scrollbar')
      this.$store.dispatch('favorites/GET_OVERVIEW', {
        params: {
          top: view.scrollTop,
          height: view.clientHeight
        },
        type: 'live',
        loader: false
      })
    }
    this.updateInterval = setInterval(function () {
      dispatchGetting()
    }, 5000)
  },
  updated () {
    let scrollbar = document.querySelector('#favorite-overview-scrollbar')
    if (!scrollbar) return
    let sport = scrollbar.querySelector('.favorite-overview-list .sport:last-child')
    if (!sport) return

    let scrollTop = parseInt(sport.style.height) + parseInt(sport.style.top) - scrollbar.clientHeight
    if (scrollbar.scrollTop > scrollTop) {
      scrollbar.scrollTop = scrollTop
    }
  },
  beforeDestroy () {
    clearInterval(this.updateInterval)
    this.$store.commit('favorites/CLEAR_LOADING', 'live')
  },
  methods: {
    getOverview () {
      let view = document.querySelector('#favorite-overview-scrollbar')
      this.$store.commit('favorites/SET_LOADER_POSITION', {
        type: 'live',
        position: 'top'
      })
      this.$store.dispatch('favorites/GET_OVERVIEW', {
        params: {
          top: 0,
          height: view.clientHeight
        },
        type: 'live'
      })
      view.scrollTop = 0
      this.$emit('scroll-to-top')
    }
  }
}
</script>

<style scoped>
.favorite-overview-list { margin: 0 10px; position: relative; }
.league .event:not(:first-child) { margin-top: 1px; }
</style>



// WEBPACK FOOTER //
// src/components/favorites/LiveList.vue